<template>
  <div :class="classes">
    <input
      type="checkbox"
      class="trbo-a-checkbox__input"
      :checked="isChecked"
      :disabled="isDisabled"
      :aria-labelledby="ariaLabelledby"
    >
    <div class="trbo-a-checkbox__box">
      <svg class="trbo-a-checkbox__box__check" width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.25 0.750488L6.75 11.25L1.5 6.00049" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
  </div>
</template>

<script>
// @flow

export default {
  inheritAttrs: false,
  props: {
    isChecked: {
      type: Boolean,
      default: false
    },
    isHovered: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    ariaLabelledby: {
      type: String,
      default: ''
    }
  },
  computed: {
    classes () {
      return {
        'trbo-a-checkbox': true,
        'trbo-a-checkbox--is-checked': this.isChecked,
        'trbo-a-checkbox--is-hovered': this.isHovered
      }
    }
  }
}
</script>

<style scoped src="./checkbox.scss" />
